/**
 * schema.org `ItemAvailability` values used in the product JSON-LD.
 *
 * Search engines read these URLs verbatim, so they stay full URLs rather than
 * the bare term.
 *
 * The enum lives in this repo rather than in shared-models because it is a
 * presentation concern of this storefront's markup, not a feed contract the
 * parser and the backends have to agree on.
 */
export enum SchemaAvailability {
  InStock = "https://schema.org/InStock",
  OutOfStock = "https://schema.org/OutOfStock",
  PreOrder = "https://schema.org/PreOrder",
  Discontinued = "https://schema.org/Discontinued",
}
